import reactiveCashflow from 'reactive-cashflow';

import CashflowUpdaterApi from '../../../api/CashflowUpdaterApi';

const actions = {
  async changeEnvelopeExpenseCategory({ dispatch }, { envelopeId, sequenceId, expenseCategory }) {
    await dispatch('applyAction', { action: 'changeEnvelopeExpenseCategory', params: { envelopeId, sequenceId, expenseCategory } });
  },
  async changeTransactionCategoryOld({ dispatch }, { expense, transaction, applyTo }) {
    const params = {
      businessName: transaction.businessName,
      transactionId: transaction.transactionId,
      applyTo,
      expense,
    };
    await dispatch('applyAction', { action: 'changeCategory', params });
  },
  async changeTransactionCategory({ dispatch }, { trackingCategoryId, matchBy, value }) {
    await dispatch('applyAction', { action: 'changeTransactionCategory', params: { trackingCategoryId, matchBy, value } });
  },
  async moveFromTrackingToExpense({ dispatch }, { transaction, expense, matchBy, value }) {
    const moveFromTrackingParams = {
      matchBy,
      value,
    };
    await dispatch('applyAction', { action: 'moveFromTracking', params: moveFromTrackingParams });
    const changeCategoryParams = {
      businessName: transaction.businessName,
      transactionId: transaction.transactionId,
      applyTo: matchBy,
      expense,
    };
    await dispatch('applyAction', { action: 'changeCategory', params: changeCategoryParams });
  },
  async moveFixedToVariable({ commit, getters, dispatch }, { transactionId, sequenceId }) {
    dispatch('applyAction', { action: 'moveFixedToVariable', params: { transactionId, sequenceId } });
  },
  async moveVariableExpenseToFixed({ commit, getters, dispatch }, { transactionId }) {
    dispatch('applyAction', { action: 'moveVariableExpenseToFixed', params: { transactionId } });
  },
  async moveVariableIncomeToFixed({ commit, getters, dispatch }, { transactionId }) {
    dispatch('applyAction', { action: 'moveVariableIncomeToFixed', params: { transactionId } });
  },
  async moveVariableIncomeToExcluded({ commit, getters, dispatch }, { transactionId }) {
    dispatch('applyAction', { action: 'excludeVariableIncome', params: { transactionId } });
  },
  async moveVariableExpenseToExcluded({ commit, getters, dispatch }, { transactionId }) {
    dispatch('applyAction', { action: 'excludeVariableExpense', params: { transactionId } });
  },
  async moveExcludedToVariableIncome({ commit, getters, dispatch }, { transactionId }) {
    dispatch('applyAction', { action: 'moveExcludedToVariableIncome', params: { transactionId } });
  },
  async moveExcludedToVariableExpense({ commit, getters, dispatch }, { transactionId }) {
    dispatch('applyAction', { action: 'moveExcludedToVariableExpense', params: { transactionId } });
  },
  async cancelEnvelope({ commit, dispatch }, envelopeId) {
    dispatch('applyAction', { action: 'cancelEnvelope', params: { envelopeId } });
  },
  async updateEnvelopeAmount({ commit, dispatch }, { envelopeId, amount }) {
    dispatch('applyAction', { action: 'updateEnvelopeAmount', params: { envelopeId, amount } });
  },
  async updateRiseupGoal({ commit, dispatch }, { budgetDate, previousAmount, amount }) {
    dispatch('applyAction', { action: 'updateRiseupGoal', params: { budgetDate, previousAmount, amount } });
  },
  async applyAction({ commit, dispatch, rootGetters }, { action, params }) {
    const currentCashflow = rootGetters['cashflowView/presentedBudget'];
    const newCashflow = reactiveCashflow.optimus[action](currentCashflow, params);
    await commit('cashflowView/setCashflowOptimistic', newCashflow, { root: true });
    await dispatch('cashflowView/resetBudgetTree', {}, { root: true });
    CashflowUpdaterApi[action](params);
  },
};

export default {
  namespaced: true,
  actions,
};
